<template>
  <div class="tabCard">
    <div class="tab">
      <div
        :class="['box', index === selectIndex ? 'select' : '']"
        v-for="(item, index) in tabList"
        :key="index"
        @click="selectType(index, item)"
      >
        <div>{{ item.dataValue }}</div>
        <div v-if="index === selectIndex" class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabCard',
  props: {
    background: {
      type: String,
      default: '#363c44',
    },
    borderRadius: {
      type: String,
      default: '43px',
    },
    tabList: {
      type: Array,
      default: () => [
        {
          dataValue: '内部停车场',
          type: '内部车场',
        },
        {
          dataValue: '外部停车场',
          type: '外部车场',
        },
      ],
    },
  },
  watch: {
    tabList: {
      handler(val) {
        console.log('watch', val)
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      selectIndex: 0,
    }
  },
  methods: {
    init() {
      this.selectIndex = 0
    },
    selectType(index, item) {
      this.selectIndex = index
      this.$emit('selectTab', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabCard {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .tab {
    flex: 1;
    width: 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    .box {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 500;
      font-size: 16px;
      color: #787878;
      line-height: 25px;
      margin-right: 33px;
      position: relative;
      .line {
        position: absolute;
        left: 24px;
        top: 29px;
        width: 30px;
        height: 3px;
        background: #19bdbf;
        border-radius: 6px;
      }
    }
    .select {
      color: #1a1a1a;
    }
  }
}
</style>
